export const DOORWAYS = [
  {
    id: 'freebies',
    name: 'Freebies',
    lines: ['Printables, wall art,', 'planners & cute', 'paper goods'],
    accent: '#6E8CA3',
    image: '/images/freebies.jpg',
    imageSm: '/images/freebies-sm.jpg',
    side: 'right',
    position: '28% center',
    href: '/freebies',
    alt: 'Long-haired red dachshund resting at a desk with botanical prints, notebooks and stationery',
    source: 'Homepage doorway',
  },
  {
    id: 'inspire',
    name: 'Inspire',
    lines: ['Woodworking ideas,', 'creative concepts', '& inspirational quotes'],
    accent: '#BE5F41',
    image: '/images/inspire.jpg',
    imageSm: '/images/inspire-sm.jpg',
    side: 'left',
    position: '72% center',
    alt: 'Black and tan dachshund in a warm woodworking studio beside a wooden dachshund figure',
    source: 'Homepage doorway',
  },
  {
    id: 'journey',
    name: 'Journey',
    lines: ['Blog posts, stories', '& heartfelt', 'dachshund-life writing'],
    accent: '#7E9070',
    image: '/images/journey.jpg',
    imageSm: '/images/journey-sm.jpg',
    side: 'right',
    position: '30% center',
    alt: 'Dachshund sitting on a mountain overlook at golden hour beside an enamel mug',
    source: 'Homepage doorway',
  },
  {
    id: 'shop',
    name: 'Shop',
    lines: ['Books, products', '& gifts for', 'dachshund lovers'],
    accent: '#B96A47',
    image: '/images/shop.jpg',
    imageSm: '/images/shop-sm.jpg',
    side: 'left',
    position: 'center center',
    alt: 'Dachshund resting its head on a stack of books next to a ceramic mug and wrapped gifts',
    source: 'Homepage doorway',
  },
];

export const NAV_ROOMS = {};

export const SOCIAL_LINKS = [
  { id: 'pinterest', label: 'Pinterest', url: 'https://www.pinterest.com/MyDachshundDays/' },
  { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@mydachshunddays' },
  { id: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/people/My-Dachshund-Days/61594984779610/' },
];
